// Plattform-Admins (Systemverwaltung): Liste, Einladungen, ernennen, entziehen. Spiegel von core/src/contracts/platform-admins.ts.
import { useQuery } from '@tanstack/react-query';
import { api } from './client';

export interface PlatformAdmin {
  id: string;
  email: string;
  displayName: string;
  status: 'active' | 'invited' | 'disabled' | 'locked';
  mfaActive: boolean;
  lastLoginAt: string | null;
  isSelf: boolean;
}
export interface PlatformAdminInvitation { id: string; email: string; displayName: string; createdAt: string; expiresAt: string; createdBy: string | null }
export interface PlatformAdmins { items: PlatformAdmin[]; invitations: PlatformAdminInvitation[]; mfaRequired: boolean; smtpConfigured: boolean }
export interface StepUp { password: string; code?: string }
export interface InviteResult { invitationId: string; email: string; expiresAt: string; token: string; mailQueued: boolean }

export const platformAdminsKey = ['platform', 'admins'] as const;
export const usePlatformAdmins = () => useQuery({ queryKey: platformAdminsKey, queryFn: () => api.get<PlatformAdmins>('/platform/admins') });

export const platformAdminApi = {
  invite: (b: { email: string; displayName: string; locale: 'de' | 'en' } & StepUp) => api.post<InviteResult>('/platform/admins/invitations', b),
  withdraw: (id: string) => api.del(`/platform/admins/invitations/${id}`),
  grant: (b: { email: string } & StepUp) => api.post<PlatformAdmin>('/platform/admins', b),
  revoke: (id: string, b: StepUp) => api.post(`/platform/admins/${id}/revoke`, b),
  accept: (b: { token: string; displayName: string; password: string }) => api.post<{ userId: string; existingAccount: boolean }>('/auth/platform-invitations/accept', b),
};

/** Link zur Annahme (Token im Fragment, wie beim Passwort-Link). */
export const platformInviteLink = (token: string) => `${window.location.origin}/admin-invite#token=${encodeURIComponent(token)}`;
